<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01">
<a id="page01">
<div class="chapterHead">
<h2 class="chapterTitle1"><span class="bold">Eve felt Talos’s dark gaze fall upon her mouth as he said softly, “I’ll show you the place where I first kissed you.”</span></h2></div>
<div class="chapterBody">
<p class="paraNoIndent1">Her bones turned to liquid. She looked up at him, her heart pounding as she licked her lips involuntarily. “Where is that?”</p>
<p class="paraNoIndent1">His eyes were hot and dark. “In Venice.”</p>
<p class="paraNoIndent1">“Venice,” she repeated, and the word was a wistful sigh. She looked up at him with yearning, knowing she should refuse—knowing she should stay in London and see the specialist Dr. Bartlett had recommended. But her refusal caught in her throat. Caught by her romantic dreams. <em class="italic">Caught by him.</em></p>
<p class="paraNoIndent1">Talos reached down to stroke her tender bottom lip with his thumb, caressing her face with his powerful hands.</p>
<p class="paraNoIndent1">“Come to Venice,” he said darkly. “I will show you everything.”</p>
<p class="paraNoIndent1">He cupped her face with both hands, holding her hard against his body as he looked down at her, commanding her with his gaze.</p>
<p class="paraNoIndent1">“And then,” he whispered, “you will marry me.”</p>
</div>
</a></div>
<a id="page01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// boughtthegreeksbaby_fm01.vue?caca94ea